import { Button } from '@material-ui/core';
import en from '../../../../lang/en-us';
import FailureScreen from '../FailureScreen';
const { dashboard } = en;

export default function BankMandateFailure() {
    return (
        <div className="curved-bg">
            <FailureScreen
                heading={dashboard.CorrectionFolios.Failure.back}
                backLink="nct/bank-mandate-selected"
                subheading={dashboard.CorrectionFolios.Failure.subHeading}
                info1={dashboard.CorrectionFolios.Failure.subHeadingInfo1}
                list={[
                    {
                        text: '1. Axis Liquid Direct Fund -IDCW Weekly Payout',
                    },
                ]}
            />
        </div>
    );
}
